<template>
  <div class="prediction-panel" v-if="sections.length">

    <!-- 弹窗通告 -->
    <div class="popup-overlay" v-if="showPopup" @click.self="showPopup = false">
      <div class="popup-box">
        <div class="popup-head">
          <span>官方公告</span>
        </div>
        <div class="popup-body" v-if="firstItem">
          <div class="popup-game">{{ gameLabel }}内幕大放送</div>
          <div class="popup-period">第{{ String(firstItem.period).slice(-3) }}期 {{ firstItem.labelText }}</div>
          <div class="popup-rows">
            <div
              v-for="(line, li) in splitRows(firstItem.contentText, 3)"
              :key="li"
              class="popup-line"
            >
              <template v-if="!line.includes('【')">【</template>
              <span
                v-for="(seg, si) in highlightSegments(line, firstItem.matchKey)"
                :key="si"
                :class="{ hl: seg.hl }"
              >{{ seg.text }}</span>
              <template v-if="!line.includes('【')">】</template>
            </div>
          </div>
          <div class="popup-divider" v-if="section12ma && item12ma"></div>
          <div v-if="section12ma && item12ma" class="popup-section">
            <div class="popup-section-title">{{ section12ma.sectionName }}</div>
            <div class="popup-rows">
              <div
                v-for="(line, li) in splitRows(item12ma.contentText, 3)"
                :key="li"
                class="popup-line"
              >
                <template v-if="!line.includes('【')">【</template>
                <span
                  v-for="(seg, si) in highlightSegments(line, item12ma.matchKey)"
                  :key="si"
                  :class="{ hl: seg.hl }"
                >{{ seg.text }}</span>
                <template v-if="!line.includes('【')">】</template>
              </div>
            </div>
          </div>
          <div class="popup-footer">
            <button class="popup-btn" @click="showPopup = false">关闭</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <template v-for="(sec, idx) in sections">
      <div :key="sec.sectionId" class="card">
        <div class="card__head">{{ gameLabel }} {{ sec.sectionName }}</div>

        <div class="card__body">
          <div
            v-for="item in sec.items"
            :key="item.id"
            class="item"
          >
            <div class="item__top">
              <span class="item__period">{{ String(item.period).slice(-3) }}期 {{ item.labelText }}</span>
              <span class="item__result" v-if="item.resultText">
                {{ item.resultText }}
                <span v-if="item.resultHit === 1" class="mark mark--hit">中</span>
                <span v-else-if="item.resultHit === 0" class="mark mark--miss">错</span>
              </span>
            </div>
            <div class="item__rows">
              <div
                v-for="(line, li) in splitRows(item.contentText, 3)"
                :key="li"
                class="item__line"
              >
                <template v-if="!line.includes('【')">【</template>
                <span
                  v-for="(seg, si) in highlightSegments(line, item.matchKey)"
                  :key="si"
                  :class="{ hl: seg.hl }"
                >{{ seg.text }}</span>
                <template v-if="!line.includes('【')">】</template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :key="'img-' + idx" class="card-img">
        <img v-if="pictureUrl[idx]" :src="pictureUrl[idx]" alt="" class="card-img__img" @click="$emit('preview-image', pictureUrl[idx])" />
        <img v-else :src="innerImages[idx % innerImages.length]" alt="" class="card-img__img" />
      </div>
    </template>
  </div>
</template>

<script>
import { fetchRecentPredictions } from '@/api/prediction'
import img1 from '@/images/inner/2.jpg'
import img2 from '@/images/inner/2468hf3.jpg'
import img3 from '@/images/inner/3.jpg'
import img4 from '@/images/inner/4949gg.gif'
import img5 from '@/images/inner/chrome.gif'
import img6 from '@/images/inner/cs666.gif'
import img7 from '@/images/inner/top.gif'
import img8 from '@/images/inner/xdddd.gif'

const innerImages = [img1, img2, img3, img4, img5, img6, img7, img8]

export default {
  name: 'PredictionTable',
  props: {
    site: { type: String, default: 'default' },
    game: { type: String, default: 'new_Hk6' },
    gameLabel: { type: String, default: '' },
    showAnnouncement: { type: Boolean, default: true },
    pictureUrl: { type: Array, default: () => [] }
  },
  data() {
    return { sections: [], loading: false, error: null, showPopup: false, innerImages }
  },
  computed: {
    todayPeriod() {
      const now = new Date()
      const start = new Date(now.getFullYear(), 0, 1)
      return Math.floor((now - start) / 86400000) + 1
    },
    firstItem() {
      const sec = this.sections[0]
      const items = sec && sec.items
      if (!items || !items.length) return null
      const target = this.todayPeriod
      const match = items.find(it => Number(it.period) % 1000 === target)
      if (match) return match
      return items.reduce((a, b) => (a.period > b.period ? a : b))
    },
    section12ma() {
      return this.sections.find(s => String(s.sectionId) === '27') || null
    },
    item12ma() {
      const sec = this.section12ma
      const items = sec && sec.items
      if (!items || !items.length) return null
      const target = this.todayPeriod
      const match = items.find(it => Number(it.period) % 1000 === target)
      if (match) return match
      return items.reduce((a, b) => (a.period > b.period ? a : b))
    }
  },
  mounted() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await fetchRecentPredictions({ site: this.site, game: this.game })
        const data = res.data
        let list = null
        if (Array.isArray(data)) list = data
        else if (data.code === 200 && data.data) {
          if (Array.isArray(data.data)) list = data.data
          else if (Array.isArray(data.data.sections)) list = data.data.sections
          else if (Array.isArray(data.data.list)) list = data.data.list
        } else if (data.data && Array.isArray(data.data)) list = data.data

        if (list && list.length) {
          this.sections = list.map(sec => {
            const items = sec.items || []
            const hits = items.filter(it => it.resultHit === 1).length
            return { ...sec, items, _hits: hits }
          })
          this.$emit('sections-loaded', this.sections)
          if (this.showAnnouncement) {
            this.showPopup = true
            this.$emit('announcement-shown')
            setTimeout(() => { this.showPopup = false }, 5000)
          }
        }
      } catch (e) {
        this.error = e.message
      } finally {
        this.loading = false
      }
    },
    splitRows(text, rows) {
      if (!text) return []
      const tags = String(text).split(/\s+/).filter(Boolean)
      const perRow = Math.ceil(tags.length / rows)
      const result = []
      for (let i = 0; i < tags.length; i += perRow) {
        result.push(tags.slice(i, i + perRow).join(' '))
      }
      return result
    },
    highlightSegments(text, matchKey) {
      if (!text || !matchKey) return [{ text: text || '' }]
      const keys = String(matchKey).split(',').map(k => k.trim()).filter(Boolean)
      if (!keys.length) return [{ text: text || '' }]
      const escaped = keys.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')
      const regex = new RegExp(`(${escaped})`, 'g')
      const parts = String(text).split(regex)
      return parts.filter(p => p !== '').map(p => ({
        text: p,
        hl: keys.includes(p)
      }))
    }
  }
}
</script>

<style scoped>
/* ---- popup ---- */
.popup-overlay {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,.55); z-index: 9999;
  display: flex; align-items: center; justify-content: center;
}
.popup-box {
  background: #fff; width: 90%; max-width: 360px;
  border-radius: 10px; overflow: hidden;
  font-family: KaiTi, STKaiti, '楷体', 'PingFang SC', 'Microsoft YaHei', serif;
}
.popup-head {
  display: flex; align-items: center; justify-content: center;
  padding: 0.7rem 1rem;
  background: linear-gradient(to right, #e02020, #c01010);
  color: #fff; font-weight: 800; font-size: 1.2rem;
}
.popup-divider { border-top: 1px dashed #ddd; margin: 0.8rem 0; }
.popup-section { margin-top: 0; }
.popup-section-title { font-weight: 800; font-size: 0.95rem; color: #153a6b; margin-bottom: 0.4rem; }
.popup-footer { margin-top: 1rem; }
.popup-btn {
  border: none; background: #e02020; color: #fff;
  padding: 0.5rem 2rem; border-radius: 6px;
  font-size: 1rem; font-weight: 600; cursor: pointer;
}
.popup-body { padding: 1.2rem 1rem; text-align: center; }
.popup-game {
  color: #153a6b; font-size: 1.1rem; font-weight: 800; margin-bottom: 0.3rem;
}
.popup-period {
  color: #5a7a9a; font-size: 1rem; font-weight: 600; margin-bottom: 0.8rem;
}
.popup-rows { display: flex; flex-direction: column; gap: 0.3rem; }
.popup-line {
  color: #e02020; font-weight: 700; font-size: 1.15rem; line-height: 1.8;
}
.popup-line .hl {
  background: #ffeb3b; padding: 0 2px; border-radius: 2px;
}

/* ---- panel ---- */
.prediction-panel { margin: 0.5rem 0 0; }

.card {
  background: #fff;
  border: 2px solid #5eb0ff;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  overflow: hidden;
  font-family: KaiTi, STKaiti, '楷体', 'PingFang SC', 'Microsoft YaHei', serif;
}

.card-img {
  margin: -0.5rem 0 0;
}
.card-img__img {
  max-width: 100%; display: block; cursor: pointer;
}

.card__head {
  padding: 0.7rem 0.75rem;
  background: linear-gradient(to right, #2196F3, #00BCD4);
  font-weight: 800;
  font-size: 1.3rem;
  color: #fff;
  text-align: center;
}

.card__body { padding: 0.35rem 0.5rem; }

.item {
  padding: 0.5rem 0.35rem;
  border-bottom: 1px solid #eee;
}
.item:last-child { border-bottom: none; }

.item__top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  margin-bottom: 0.4rem;
}

.item__period {
  color: #5a7a9a;
  font-weight: 600;
  font-size: 0.85rem;
}

.item__result {
  color: #e02020;
  background: #b3e5fc;
  font-weight: 600;
  font-size: 0.82rem;
  padding: 0.15rem 0.45rem;
  border-radius: 4px;
}

.mark {
  display: inline-block;
  font-size: 0.65rem;
  padding: 1px 6px;
  border-radius: 3px;
  color: #fff;
  margin-left: 3px;
  font-weight: 700;
}
.mark--hit  { background: #38a169; }
.mark--miss { background: #e53e3e; }

.item__rows {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.item__line {
  color: #e02020;
  font-weight: 700;
  font-size: 0.95rem;
  line-height: 1.7;
  word-break: normal;
  overflow-wrap: anywhere;
  text-align: center;
}

.item__line .hl {
  background: #ffeb3b;
  color: #e02020;
  padding: 0 2px;
  border-radius: 2px;
}
</style>
